<template>
  <div class="log">
    <header>
      <p v-on:click="backHistory" style="padding-left: 0; " @click="">
        <img src="@/assets/img/back.png" alt="">
        <span style="color: #FFFFFF">添加工作经历</span>
      </p>
      <!--<p style="padding-right: 2rem;color: #FFFFFF ">删除</p>-->
    </header>
    <div class="personalMain">
      <!--<div class="inforName">-->
      <!--&lt;!&ndash;<van-cell-group>&ndash;&gt;-->
      <!--<van-field label="公司名称" color="#DEDEDE"  readonly />-->
      <!--<van-field   value="达达快递" placeholder="1994.03" />-->
      <!--</div>-->
      <div class="inforName">
        <p class="inforNameTop">公司名称</p>
        <p> <input class="inforNameInput" v-model="data.name" type="text" placeholder="请填写" ></p>
      </div>
      <div class="inforName">
        <p class="inforNameTop">公司行业</p>
        <p><input class="inforNameInput" v-model="data.industry" type="text" placeholder="请填写"></p>
      </div>
      <div class="inforName">
        <p class="inforNameTop">在职时间</p>
        <p style="display: flex"><input class="inforTime" v-model="data.entrytime" type="text"  placeholder="2014.08"><span>--</span>
          <input class="inforTime" v-model="data.resigntime" type="text"  placeholder="2014.08"></p>
      </div>
      <div class="inforName">
        <p class="inforNameTop">职位类型</p>
        <p><input class="inforNameInput" v-model="data.positiontype" type="text" placeholder="请填写"></p>
      </div>
      <div class="inforName">
        <p class="inforNameTop">职位名称</p>
        <p><input class="inforNameInput" v-model="data.positionname" type="text" placeholder="请填写"></p>
      </div>
      <div class="inforName">
        <p class="inforNameTop">所属部门</p>
        <p><input class="inforNameInput" v-model="data.department" type="text" placeholder="请填写"></p>
      </div>
      <div class="inforName">
        <p class="inforNameTop">工作内容</p>
        <p>
          <textarea style="width: 100%;height: 5rem" v-model="data.workdescription" placeholder="请填写"></textarea>
        </p>
      </div>

    </div>
    <div class="inforName">
      <van-button style="width: 100%;margin: 0 auto" type="primary" @click="addWorker()">保存</van-button>

    </div>
  </div>
</template>
<script>
  export default {
    name:'',
    data(){
      return {
        msg: "",
        data:{
          name:'',
          industry:"",
          entrytime:"",
          resigntime:"",
          positiontype:'',
          positionname:"",
          department:"",
          workdescription:''
        }
      }
    },
    methods:{
      backHistory(){
        this.$router.go(-1)
      },
      addWorker(){
        console.log(this.data)
        this.$api.addWork({
          "data[name]": this.data.name,
          "data[industry]": this.data.industry,
          "data[entrytime]": this.data.entrytime,
          "data[resigntime]": this.data.resigntime,
          "data[positiontype]": this.data.positiontype,
          "data[positionname]": this.data.positionname,
          "data[department]": this.data.department,
          "data[workdescription]":this.data.workdescription,
          "data[resumeid]":this.$route.params.id
        }).then(res=>{
          this.$router.push("/editResume")
        }).catch(err=>{
        })
      },
    }
  }
</script>
<style scoped="">
  header{
    width: 100%;
    height: 85px;
    background-color: #6e9bcf;
    position: fixed;
    top:0 ;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 1rem;
  }
  header img{
    width: 20px;
    /*height: 20px;*/
  }
  .personalMain{
    /*padding-top: 82px;*/
    padding: 8rem 18px 0 18px;
  }
  .inforName{
    border-bottom: solid 1px #DEDEDE;
  }
  .inforName input{
    border: none;
  }
  .inforNameInput{
    width: 100%;
    border: none;
  }
  /*.inforName :first-child{*/
  /*font-size: 13px;*/
  /*}*/
  .inforNameTop{
    font-size: 13px;
    color: grey;
  }
  .inforTime{
    width: 43%;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/addWork.vue